import { SortBy } from "../../../components/Analysis/utils/types";

export const LOAD_MONITORING = "bonfire/monitoring/LOAD_MONITORING";
export const LOAD_MONITORING_REQUEST =
  "bonfire/monitoring/LOAD_MONITORING_REQUEST";
export const LOAD_MONITORING_REQUEST_SUCCESS =
  "bonfire/monitoring/LOAD_MONITORING_REQUEST_SUCCESS";
export const LOAD_MONITORING_REQUEST_FAIL =
  "bonfire/monitoring/LOAD_MONITORING_REQUEST_FAIL";
export const UPDATE_MONITORING = "bonfire/monitoring/UPDATE_MONITORING";
export const UPDATE_SORT_BY_OPTION = "bonfire/monitoring/UPDATE_SORT_BY_OPTION";

interface LoadMonitoring {
  type: typeof LOAD_MONITORING;
}

export interface LoadMonitoringRequestPayload {
  siteIds: Array<string>;
  daysRange: number;
  token: string;
}

interface LoadMonitoringRequestSuccess {
  type: typeof LOAD_MONITORING_REQUEST_SUCCESS;
  result: any;
}

interface LoadMonitoringRequestFail {
  type: typeof LOAD_MONITORING_REQUEST_FAIL;
  error: string;
}

interface UpdateMonitoring {
  type: typeof UPDATE_MONITORING;
  siteGroups: any /* FIXME: type */;
  composed: any /* FIXME: type */;
}

interface UpdateSortByOption {
  type: typeof UPDATE_SORT_BY_OPTION;
  sortByOption: SortBy;
}

export type Action =
  | LoadMonitoring
  | LoadMonitoringRequestSuccess
  | LoadMonitoringRequestFail
  | UpdateMonitoring
  | UpdateSortByOption;
